__turbopack_context__.v({
  "divider": "MoreOrganizerEvents-module-scss-module__dpsu4a__divider",
  "dividerContainer": "MoreOrganizerEvents-module-scss-module__dpsu4a__dividerContainer",
  "hiddenSeoCopy": "MoreOrganizerEvents-module-scss-module__dpsu4a__hiddenSeoCopy",
  "moreOrganizerEventsContainer": "MoreOrganizerEvents-module-scss-module__dpsu4a__moreOrganizerEventsContainer",
  "subtitle": "MoreOrganizerEvents-module-scss-module__dpsu4a__subtitle",
  "title": "MoreOrganizerEvents-module-scss-module__dpsu4a__title",
  "undeterminedVenue": "MoreOrganizerEvents-module-scss-module__dpsu4a__undeterminedVenue",
});
